import { gql } from "@apollo/client";

const VERIFY_GUEST_TOKEN = gql`
  query VerifyGuestToken($token: String!) {
  verifyGuestToken(token: $token) {
    email
    issuedAt
    valid
    traineeshipID
  }
}
`;

export default VERIFY_GUEST_TOKEN;